// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Shop_Contact__gKAaA","Contact__title":"Shop_Contact__title__2l5r1","Contact__p":"Shop_Contact__p__2rYz1"};